import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const childcareConsultationChat: BlogMetaData = {
  title: '悩み相談チャット無料おすすめ5選｜夜中でも使える育児相談を比較【2026年】',
  description:
    '悩み相談チャットを無料で使えるサービスを厳選比較。深夜でも即対応・匿名OK・モンテッソーリAI相談など、育児の悩み別におすすめを解説します。',
  thumbnailUrl: '/img/blog-childcare-consultation-chat.png',
  filePath: buildBlogFilePath('childcare-consultation-chat'),
  category: BLOG_CATEGORY.PARENTING,
};
